import React from 'react';

import classes from './Toolbar.module.css';

import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';

const Toolbar = (props) => {
	return (
		<header className={classes.Toolbar}>
			<DrawerToggle drawerToggle={props.toggleSideDrawer} />
			<div className={classes.Logo}>
				<Logo />
			</div>
			<nav className={classes.DesktopOnly}>
				<NavigationItems isAuthenticated={props.isAuthenticated} />
			</nav>
		</header>
	);
};

export default Toolbar;
